
import { defineComponent, ref, inject, onMounted, onBeforeMount } from "vue";
// eslint-disable-next-line no-unused-vars
import IAuthenticationService from "../interfaces/authentication_service";
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "../interfaces/configuration_service";
// eslint-disable-next-line no-unused-vars
import IRegions, { IRegionFilters } from "@/interfaces/region_filters";

import router from "../router";

interface IRegionSelectorOption
{
	region: string
}

export default defineComponent({
	setup()
	{
		const regionInputRef = ref<HTMLElementTagNameMap>();
		const authenticationService = inject<IAuthenticationService>("authenticationService");
		const configurationService = inject<IConfigurationService>("configurationService");
		
		const options = ref<IRegions>();
		const selectedOption = ref<IRegionSelectorOption>();
		const isDisabled = ref<boolean>();
		const isFeis = ref<boolean>(false);
		const isClass = ref<boolean>(false);
		const hasLogo = ref<boolean>(false);
		const logoSrc = ref<string>("");
		const hasSyllabus = ref<boolean>(false);
		const syllabusName = ref<string>("/syllabus/Brady Academy Feis.pdf");

		if (!configurationService)
		{
			throw new Error("Configuration service not initialised");
		}

		async function submit(evt:Event)
		{
			console.log(`SUBMIT button pressed...`)
			if (!authenticationService)
			{
				console.log(`Authentication service not initialised...`)
			
				throw new Error("Authentication service not initialised");
			}

			if (evt)
			{
				evt.preventDefault();
			}
			authenticationService.setTempAuthentication();
						
			router.replace({ name: "music" });
		}

		function loadRegionFilters()
		{
			let regionFilters = configurationService?.getOnlineFeisList();
			if (regionFilters)
			{
				options.value = regionFilters;
			}
		}

		function onChange(event: any)
		{
			isFeis.value = false;
			isClass.value = false;
			hasLogo.value = false;
			logoSrc.value = "";
			hasSyllabus.value = false;
			syllabusName.value = "";

			if (event.target.value)
			{
				// Just set the selected region so that we can use it later
				isDisabled.value = false;
				configurationService?.setSelectedRegion(event.target.value);

				const region = configurationService?.getSelectedRegion();
				if (region)
				{
					const isAFeis = region?.map((item: IRegionFilters) => item?.isFeis);
					const isAClass = region?.map((item: IRegionFilters) => item?.isClass);
					const hasALogo = region?.map((item: IRegionFilters) => item?.hasLogo);
					const hasASyllabus = region?.map((item: IRegionFilters) => item?.hasSyllabus);

					isFeis.value = (isAFeis && isAFeis[0] === "true");	
					isClass.value = (isAClass && isAClass[0] === "true");
					hasLogo.value = (hasALogo && hasALogo[0] === "true");
					if (hasLogo.value)
					{
						logoSrc.value = region?.map((item: IRegionFilters) => item?.logoSrc)
					}
					hasSyllabus.value = (hasASyllabus && hasASyllabus[0] === "true");	
					if (hasSyllabus.value)
					{
						syllabusName.value = region?.map((item: IRegionFilters) => item?.syllabusName);
					}
				}
			}
			else
			{
				isDisabled.value = true;
			}
		}

		onBeforeMount(function()
		{
			isDisabled.value = true;
			loadRegionFilters();
		});
		
		onMounted(function()
		{
			setTimeout(() => 
			{
				if (regionInputRef.value)
				{
					// regionInputRef.value.focus();
				}
				
			}, 300);
		});

		return {
			regionInputRef,
			submit,
			options,
			selectedOption,
			onChange,
			isDisabled,
			isFeis,
			isClass,
			hasLogo,
			logoSrc,
			hasSyllabus,
			syllabusName
		};
	}
});
